




















import { Vue,Component, Prop } from "vue-property-decorator";
import UsersListItem from './UsersListItem.vue';
import UserBlock from "../../common/user/UserBlock.vue";
import debounce from "lodash.debounce";
import { Location } from "vue-router";

@Component({
    components: { UsersListItem, UserBlock }
})
export default class UsersList extends Vue {
    @Prop({required: true}) renderList: any[];
    @Prop({required: true}) needPopup: boolean;
    @Prop({default: 0}) usersMoreAmount: number;
    @Prop({default: 32}) userIconSize: number;
    @Prop({default: ''}) speakerClassName: string;
    @Prop({ default: false }) hideInfo: boolean;
    @Prop({ default: null }) moreAmountLink: Location

    resizeObserver: ResizeObserver | null = null;

    mounted() {
        this.setResizeObserver();
    }

    beforeDestroy() {
        this.resizeObserver?.disconnect();
    }

    setResizeObserver() {
        //debounce with decorator does not allow event emit
        const handler = debounce(() => {
            this.emitUpdateList()
        }, 5);

        if(ResizeObserver) {
            this.resizeObserver = new ResizeObserver(handler);
            this.resizeObserver.observe(this.$el as Element);
        }
    }

    emitUpdateList() {
        this.$el.classList.add('users-list_cleaned')
        this.$emit('updateList');
        this.$nextTick(() => {
            this.$el.classList.remove('users-list_cleaned')
        })

    }

    getKey(id: string) {
        //поддерка до параметра для ключа
        return id;
    }
}
